import EventBus, {Events} from '../../../event-bus'

export const onPress = (item) => {
  EventBus.$emit(Events.B_MENU_ITEM_CLICKED, item)
}
